import React from "react";
import "./CTASection.css";

const CTASection = ({
  title = "Book Your Mumbai to Shirdi Cab Today",

  description =
    "Travel from Mumbai to Sai Shirdi with safe, comfortable and reliable cab service. Enjoy doorstep pickup, professional chauffeurs and convenient one-way or round-trip taxi options.",

  buttonText = "Book Shirdi Cab",

  buttonLink = "/booking",

  termsLink = "/term-condition",

  expiry = "2 days, 14 hours",

  phone = "+91 77768 14559",

  backgroundImage = "/images/bg-img.jpg",
}) => {
  return (
    <section className="cta-wrapper">

      <div
        className="cta-box"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >

        <div className="cta-overlay"></div>

        <div className="cta-content">

          {/* Left */}

          <div className="cta-left">

            <div className="cta-title">

              <div className="cta-lines">

                <span></span>
                <span></span>
                <span></span>

              </div>

              <h2>
                {title}
              </h2>

            </div>

            <p className="cta-description">
              {description}
            </p>

            <div className="cta-buttons">

              <a
                href={buttonLink}
                className="cta-btn"
              >
                {buttonText}

                <span>
                  📅
                </span>
              </a>

              <a
                href={termsLink}
                className="terms-link"
              >
                View Terms
              </a>

            </div>

            {/*
            <p className="expiry-text">

              Offer expires in

              <strong>
                {expiry}
              </strong>

            </p>
            */}

          </div>

          {/* Right */}

          <div className="cta-phone">

            <span>
              Book Your Shirdi Cab
            </span>

            <a
              href={`tel:${phone.replace(/\s|-/g, "")}`}
            >
              {phone}
            </a>

          </div>

        </div>

      </div>

    </section>
  );
};

export default CTASection;
